<template>
<div class="">
    <!-- Modal -->
    <div class="modal fade" id="manageDeviceModal" tabindex="-1" aria-labelledby="manageDeviceModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ editMode ? 'แก้ไขอุปกรณ์' : 'เพิ่มอุปกรณ์ใหม่' }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="">
                        <!-- configData {{ configData }} -->
                        <!-- Main Form Card -->
                        <div class="px-2">
                            <!-- Device Information Section -->
                            <div class="section-header mb-4">
                                <i class="bi bi-info-circle-fill me-2"></i>
                                <h5 class="mb-0">ข้อมูลอุปกรณ์</h5>
                            </div>

                            <div class="row g-4 mb-5">
                                <div class="col-lg-6">
                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-pc-display me-2"></i>ชื่ออุปกรณ์
                                        </label>
                                        <input type="text" class="custom-input" placeholder="Enter device name" v-model="dataDeviceOne.devices[0].name">
                                    </div>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-upc-scan me-2"></i>จุดติดตั้ง
                                        </label>
                                        <input type="text" class="custom-input" placeholder="Enter plan name" v-model="dataDeviceOne.plan.location">
                                    </div>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-building me-2"></i>ลูกค้า
                                        </label>
                                        <input type="text" class="custom-input" placeholder="Enter customer name" v-model="dataDeviceOne.plan.customer">
                                    </div>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-cpu me-2"></i>โมเดล
                                        </label>
                                        <input type="text" class="custom-input" placeholder="Enter model" v-model="dataDeviceOne.plan.model">
                                    </div>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-mailbox me-2"></i>รหัสไปรษณีย์
                                        </label>
                                        <input type="text" class="custom-input" placeholder="Enter postcode" v-model="dataDeviceOne.plan.postcode">
                                    </div>

                                    <!-- <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-cpu me-2"></i>Serial Number
                                        </label>
                                        <input type="text" class="custom-input" placeholder="Enter serial number" v-model="device.snumber">
                                    </div> -->
                                </div>

                                <div class="col-lg-6">
                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-geo-alt me-2"></i>ชื่อสถานที่
                                        </label>
                                        <input type="text" class="custom-input" placeholder="Enter location" v-model="dataDeviceOne.plan.name">
                                    </div>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-map me-2"></i>จังหวัด
                                        </label>
                                        <input type="text" class="custom-input" placeholder="Enter province" v-model="dataDeviceOne.plan.province">
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6 mb-4">
                                            <label class="custom-label">
                                                <i class="bi bi-compass me-2"></i>ละติจูด
                                            </label>
                                            <input type="number" step="0.000001" class="custom-input" placeholder="0.000000" v-model="dataDeviceOne.plan.Latitude">
                                        </div>

                                        <div class="col-md-6 mb-4">
                                            <label class="custom-label">
                                                <i class="bi bi-compass-fill me-2"></i>ลองจิจูด
                                            </label>
                                            <input type="number" step="0.000001" class="custom-input" placeholder="0.000000" v-model="dataDeviceOne.plan.Longitude">
                                        </div>
                                    </div>

                                    <!-- <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-toggle-on me-2"></i>สถานะ
                                        </label>
                                        <select class="custom-input" v-model="device.status">
                                            <option value="0">ไม่ทำงาน</option>
                                            <option value="1">ทำงานปกติ</option>
                                            <option value="2">ผิดปกติ</option>
                                        </select>
                                    </div> -->

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-journal-text me-2"></i>คำอธิบาย
                                        </label>
                                        <textarea class="custom-input" rows="3" placeholder="Enter description..." v-model="dataDeviceOne.plan.description"></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="section-header mb-3">
                                <i class="bi bi-broadcast-pin me-2"></i>
                                <h5 class="mb-0">การเชื่อมต่อข้อมูลของอุปกรณ์</h5>
                            </div>

                            <div class="row g-4 mb-5">
                                <div class="col-lg-6">
                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-arrow-left-right me-2"></i>ชนิดการสื่อสาร
                                        </label>
                                        <select class="custom-input" v-model="dataDeviceOne.devices[0].mode" @change="generateKey_MQTT()">
                                            <option value="mqtt">MQTT</option>
                                            <option value="api">API</option>
                                        </select>
                                    </div>

                                    <!-- MQTT Configuration -->
                                    <div v-if="dataDeviceOne.devices[0].mode=='mqtt'" class="config-box">
                                        <div class="config-header">
                                            <i class="bi bi-router me-2"></i>
                                            <strong>MQTT Configuration</strong>
                                        </div>

                                        <div class="config-item">
                                            <label class="config-label">Topic</label>
                                            <div class="input-group-custom">
                                                <input type="text" class="custom-input-small" placeholder="Enter topic" v-model="mqtt.topic">
                                                <button class="btn-copy" @click="copyTextFallback(mqtt.topic)">
                                                    <i class="bi bi-clipboard"></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div class="config-item">
                                            <label class="config-label">Client ID</label>
                                            <div class="input-group-custom">
                                                <input type="text" class="custom-input-small" placeholder="Auto-generated" v-model="mqtt.id">
                                                <button class="btn-copy" @click="copyTextFallback(mqtt.id)">
                                                    <i class="bi bi-clipboard"></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div class="config-item">
                                            <label class="config-label">Username</label>
                                            <div class="input-group-custom">
                                                <input type="text" class="custom-input-small"  v-model="mqtt.username">
                                                <button class="btn-copy" @click="copyTextFallback(mqtt.username)">
                                                    <i class="bi bi-clipboard"></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div class="config-item">
                                            <label class="config-label">Password</label>
                                            <div class="input-group-custom">
                                                <input type="text" class="custom-input-small"  v-model="mqtt.password">
                                                <button class="btn-copy" @click="copyTextFallback(mqtt.password)">
                                                    <i class="bi bi-clipboard"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- API Configuration -->
                                    <div v-else class="config-box">
                                       <!-- aaaaaaa{{ dataDeviceOne.devices[0].config. }}   -->
                                      <div class="config-header">
                                            <i class="bi bi-plugin me-2"></i>
                                            <strong>API Configuration</strong>
                                        </div>
                                        <div class="mb-3" v-if="dataDeviceOne.devices[0].mode=='api' && dataDeviceOne.devices[0].config.auth">
                                            <label class="custom-label">
                                                <i class="bi bi-key me-2"></i>Authentication Type
                                            </label>
                                           
                                            <select class="custom-input" v-model="dataDeviceOne.devices[0].config.auth.type">
                                                <option value="apikey">API Key</option>
                                                <option value="bearer">Bearer Token</option>
                                                <option value="basic">Basic Authentication</option>
                                            </select>
                                        </div>

                                    <div v-if="dataDeviceOne.devices[0].mode=='api' && dataDeviceOne.devices[0].config.auth">
                                          <!-- API Key Mode -->
                                        <div v-if="dataDeviceOne.devices[0].config.auth.type=='apikey'">
                                            <div class="mb-3">
                                                <label class="config-label">Key Location</label>
                                                <select class="custom-input-small" v-model="api.in">
                                                    <option value="header">Header</option>
                                                    <option value="query">Query Parameter</option>
                                                </select>
                                            </div>

                                            <div class="mb-3">
                                                <label class="config-label">Key Name</label>
                                                <input type="text" class="custom-input-small" placeholder="e.g. X-API-Key" v-model="api.key">
                                            </div>

                                            <div class="mb-3">
                                                <label class="config-label">Key Value</label>
                                                <input type="text" class="custom-input-small" placeholder="Enter API key value" v-model="api.value">
                                            </div>
                                        </div>

                                        <!-- Bearer Token Mode -->
                                        <div v-else-if="dataDeviceOne.devices[0].config.auth.type=='bearer'">
                                            <div class="mb-3">
                                                <label class="config-label">Bearer Token</label>
                                                <input type="text" class="custom-input-small" placeholder="Enter bearer token" v-model="api.token">
                                            </div>
                                        </div>

                                        <!-- Basic Auth Mode -->
                                        <div v-else-if="dataDeviceOne.devices[0].config.auth.type=='basic'">
                                            <div class="mb-3">
                                                <label class="config-label">Username</label>
                                                <input type="text" class="custom-input-small" placeholder="Enter username" v-model="dataDeviceOne.devices[0].config.auth.username">
                                            </div>

                                            <div class="mb-3">
                                                <label class="config-label">Password</label>
                                                <input type="text" class="custom-input-small" placeholder="Enter password" v-model="dataDeviceOne.devices[0].config.auth.password">
                                            </div>
                                        </div>
                                    </div>

                                        <!-- <div class="mb-3">
              <label class="config-label">Device ID (Optional)</label>
              <input 
                type="text" 
                class="custom-input-small" 
                placeholder="Enter device ID" 
                v-model="api.deviceId"
              >
            </div> -->
                                    </div>
                                </div>

                                <div class="col-lg-6">
                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-file-text me-2"></i>Template
                                        </label>
                                        <select class="custom-input" v-model="dataDeviceOne.devices[0].template_id">
                                            <option value="" disabled>Select a template</option>
                                            <option v-for="item in list_template" :key="item.id" :value="item.id">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-chat-left-text me-2"></i>Additional Notes
                                        </label>
                                        <textarea class="custom-input" rows="6" placeholder="Add any additional notes..." v-model="dataDeviceOne.devices[0].comment"></textarea>
                                    </div>
                                </div>
                            </div>

                            <!-- Action Buttons -->
                            <div class="button-row mt-4">
                                <button @click="clearForm()" class="btn-clear">
                                    <i class="bi bi-arrow-counterclockwise me-2"></i>Clear Form
                                </button>
                                <button @click="editMode ? editDevice(editPlanId) : createDevice()" class="btn-create">
                                    <i class="bi bi-check-circle me-2"></i>{{ editMode ? 'Update Device' : 'Create Device' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="dashboard">
        <!-- Header -->
        <header class="header">
            <div class="container">
                <div class="header-content">
                    <h1>รายการอุปกรณ์</h1>
                    <div class="search-box">
                        <button type="button" class="btn btn-dark px-3 rounded-5" data-bs-toggle="modal" data-bs-target="#manageDeviceModal" @click="clearForm()"> + เพิ่มอุปกรณ์</button>
                    </div>
                </div>
            </div>
        </header>

        <!-- Main Content -->
        <div class="container main-content">

            <!-- Customers Table -->
            <div class="customers-section">
                <div class="section-header">
                    <div class="col-12">
                        <div class="" style="font-size: 20px;">อุปกรณ์ทั้งหมด</div>
                        <div class="row mt-2">
                            <div class="col-6">
                                <div class="search-box">
                                    <i class="bi bi-search" style="color: grey;font-size: 16px;"></i>
                                    <input v-model.trim="q" @keyup.enter="reload" type="search" class="form-control rounded-5" placeholder="ค้นหาอุปกรณ์ (กด Enter)" style="max-width: 260px; min-width: 200px;" />
                                </div>
                            </div>
                            <div class="col-6  ">
                                <div class="row justify-content-end align-items-center me-2">
                                    <select v-model.number="size" class="form-select col-6" style="width: 120px;">
                                        <option :value="10">10 / หน้า</option>
                                        <option :value="20">20 / หน้า</option>
                                        <option :value="50">50 / หน้า</option>
                                    </select>
                                    <button class="btn btn-outline-dark col-2 ms-2" :disabled="loading" @click="reload">
                                        {{ loading ? "กำลังโหลด..." : "รีเฟรช" }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="table-wrapper">
                    <table class="customers-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>ชื่ออุปกรณ์</th>
                                <th>ที่ตั้งอุปกรณ์</th>
                                <th>รุ่นอุปกรณ์</th>
                                <th>Edit</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr v-for="(itemdevice, index) in list_device" :key="index">
                                <td class="text-center">{{ index+1 }}</td>
                                <td>{{ itemdevice.name }}</td>
                                <td>{{ itemdevice.location }}</td>
                                <td>{{itemdevice.model}}</td>
                                <td>
                                    <span class="edit_btn px-1 py-1 rounded-2" @click="getDeviceOneWithPlanID(itemdevice.id),openEditModal(itemdevice)" style="cursor: pointer;">
                                        <i class="bi bi-pen"></i> แก้ไข
                                    </span>
                                    <span type="button" @click="deleteDevice(itemdevice.id)" class="remove_btn px-3 py-1 rounded-2 ms-2" style="cursor: pointer;">
                                        <i class="bi bi-trash3"></i> ลบ
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="pagination">
                    <div class="pagination-info">
                        <!-- Showing data 1 to 8 of 256K entries -->
                    </div>
                    <div class="d-flex justify-content-between align-items-center mt-2 mb-4">
                        <div class="text-muted">
                            ทั้งหมด: {{ total }} รายการ
                        </div>
                        <div class="btn-group ms-1">
                            <button class="btn btn-outline-secondary" :disabled="page <= 1 || loading" @click="prevPage">ก่อนหน้า</button>
                            <span class="btn btn-outline-secondary disabled">หน้า {{ page }}</span>
                            <button class="btn btn-outline-secondary" :disabled="disableNext || loading" @click="nextPage">ถัดไป</button>
                        </div>
                    </div>
                    <!-- <div class="pagination-controls">
            <button class="page-btn" @click="prevPage" :disabled="currentPage === 1">
              <i class="bi bi-chevron-left"></i>
            </button>
            <button 
              v-for="page in visiblePages" 
              :key="page"
              :class="['page-btn', { active: currentPage === page }]"
              @click="currentPage = page"
            >
              {{ page }}
            </button>
            <button class="page-btn" v-if="totalPages > 5">...</button>
            <button class="page-btn" @click="currentPage = 40">40</button>
            <button class="page-btn" @click="nextPage" :disabled="currentPage === totalPages">
              <i class="bi bi-chevron-right"></i>
            </button>
          </div> -->
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import * as bootstrap from 'bootstrap';
import CryptoJS from "crypto-js";

export default {
    data() {
        return {
          dataDeviceOne:{
            plan: {
                // id: "",
                name: "",
                customer:"",
                instrument: "",
                model: "",
                location: "",
                postcode: "",
                province: "",
                status: "",
                Latitude: "",
                Longitude: "",
                setting: {},
                description: "",
                createdAt: "",
                updatedAt: ""
            },
             devices: [{
                // id: "",
                name: "",
                snumber: "",
                comment: "",
                mode: "api",
                type: "",
                config:  {
                auth:{type: "basic"},
                },
                
                status: 0,
                template_id: "",
                planId: "",
            }],
          },

            plan: {
                id: "",
                name: "",
                customer:"",
                instrument: "",
                model: "",
                location: "",
                postcode: "",
                province: "",
                status: "",
                Latitude: "",
                Longitude: "",
                setting: {},
                description: "",
                createdAt: "",
                updatedAt: ""
            },
            devices: [{
                id: "",
                name: "",
                snumber: "",
                comment: "",
                mode: "",
                config:  {},
                status: 0,
                template_id: "",
                planId: "",
            }],
            configData: "",
            editMode: false,
            editPlanId: null,
            list_plan: [],
            // device: {
            //     template_id: "",
            //     plan_name: "",
            //     customer: "",
            //     instrument: "",
            //     model: "",
            //     postcode: "",
            //     location: "",
            //     province: "",
            //     status: 1,
            //     latitude: "",
            //     longitude: "",
            //     setting: "",
            //     description: "",
            //     snumber: "",
            //     name: "",
            //     mode: "api",
            //     comment: "",
            //     device_id: null
            // },
            // api: {
            //     mode: "basic",
            //     in: "header",
            //     key: "X-API-Key",
            //     value: "",
            //     username: "",
            //     password: "",
            //     token: "",
            //     deviceId: ""
            // },
            // mqtt: {
            //     id: "",
            //     topic: "",
            //     username: "",
            //     password: ""
            // },
            list_template: [],
            loading: false,
            q: "",
            page: 1,
            size: 10,
            total: 0,
            tableSearch: "",
            sortBy: "Newest",
            currentPage: 1,
            totalPages: 40,
            visiblePages: [1, 2, 3, 4, 5],
            list_device: []
        };
    },
    computed: {
        disableNext() {
            return this.page * this.size >= this.total;
        },
    },
    methods: {
        generateKey_MQTT() {
            if (this.device.mode === 'mqtt') {
                this.mqtt.id = CryptoJS.lib.WordArray.random(8).toString(CryptoJS.enc.Base64).replace(/[^a-zA-Z0-9]/g, '');
                this.mqtt.username = CryptoJS.lib.WordArray.random(12).toString(CryptoJS.enc.Base64).replace(/[^a-zA-Z0-9]/g, '');
                this.mqtt.password = CryptoJS.lib.WordArray.random(12).toString(CryptoJS.enc.Base64).replace(/[^a-zA-Z0-9]/g, '');
            }
        },

        async createDevice() {
            try {
                // Validate required fields
                // if (!this.device.plan_name || !this.device.customer) {
                //     alert('กรุณากรอกข้อมูล Plan Name และ Customer');
                //     return;
                // }

                // if (!this.device.name || !this.device.template_id) {
                //     alert('กรุณากรอกชื่ออุปกรณ์และเลือก Template');
                //     return;
                // }

                // // Plan data
                // const plan = {
                //     name: this.device.plan_name,
                //     customer: this.device.customer,
                //     instrument: this.device.instrument || "",
                //     model: this.device.model || "",
                //     postcode: this.device.postcode || "",
                //     location: this.device.location || "",
                //     province: this.device.province || "",
                //     status: parseInt(this.device.status) || 1,
                //     Latitude: parseFloat(this.device.latitude) || 0,
                //     Longitude: parseFloat(this.device.longitude) || 0,
                //     setting: this.device.setting || "",
                //     description: this.device.description || ""
                // };

                // // Device config based on mode
                // let device_config = {};

                // if (this.device.mode === 'api') {
                //     if (this.api.mode === 'apikey') {
                //         device_config = {
                //             auth: {
                //                 type: 'apikey',
                //                 in: this.api.in,
                //                 key: this.api.key,
                //                 value: this.api.value
                //             }
                //         };
                //     } else if (this.api.mode === 'bearer') {
                //         device_config = {
                //             auth: {
                //                 type: 'bearer',
                //                 token: this.api.token
                //             }
                //         };
                //     } else if (this.api.mode === 'basic') {
                //         device_config = {
                //             auth: {
                //                 type: 'basic',
                //                 username: this.api.username,
                //                 password: this.api.password
                //             }
                //         };
                //     }

                //     if (this.api.deviceId) {
                //         device_config.deviceId = this.api.deviceId;
                //     }
                // } else if (this.device.mode === 'mqtt') {
                //     device_config = {
                //         topic: this.mqtt.topic,
                //         clientId: this.mqtt.id,
                //         username: this.mqtt.username,
                //         password: this.mqtt.password
                //     };
                // }

                // // Final request body
                // const body_create_device = {
                //     plan: plan,
                //     devices: [{
                //         name: this.device.name,
                //         comment: this.device.comment || "",
                //         mode: this.device.mode,
                //         snumber: this.device.snumber || "",
                //         template_id: this.device.template_id,
                //         config: device_config
                //     }]
                // };

                // console.log('Creating device with data:', body_create_device);

                const accessToken = localStorage.getItem("accessToken");
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/plan/with-devices`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify(this.dataDeviceOne)
                });

                if (!response.ok) {
                    const error = await response.json();
                    throw new Error(error.message || `HTTP error! status: ${response.status}`);
                }

                const result = await response.json();
                console.log('Device created successfully:', result);

                alert('สร้างอุปกรณ์สำเร็จ');
                this.clearForm();
                this.getAllDevice();

                // Close modal
                const modal = bootstrap.Modal.getInstance(document.getElementById('manageDeviceModal'));
                if (modal) modal.hide();

            } catch (error) {
                console.error('Error creating device:', error);
                alert('เกิดข้อผิดพลาด: ' + error.message);
            }
        },

        async editDevice(planId) {
            try {
                // if (!this.device.plan_name || !this.device.customer) {
                //     alert('กรุณากรอกข้อมูล Plan Name และ Customer');
                //     return;
                // }

                // if (!this.device.name || !this.device.template_id) {
                //     alert('กรุณากรอกชื่ออุปกรณ์และเลือก Template');
                //     return;
                // }

                // // Plan data
                // const plan = {
                //     name: this.device.plan_name,
                //     customer: this.device.customer,
                //     instrument: this.device.instrument || "",
                //     model: this.device.model || "",
                //     postcode: this.device.postcode || "",
                //     location: this.device.location || "",
                //     province: this.device.province || "",
                //     status: parseInt(this.device.status) || 1,
                //     Latitude: parseFloat(this.device.latitude) || 0,
                //     Longitude: parseFloat(this.device.longitude) || 0,
                //     setting: this.device.setting || "",
                //     description: this.device.description || ""
                // };

                // // Device config based on mode
                // let device_config = {};

                // if (this.device.mode === 'api') {
                //     if (this.api.mode === 'apikey') {
                //         device_config = {
                //             auth: {
                //                 type: 'apikey',
                //                 in: this.api.in,
                //                 key: this.api.key,
                //                 value: this.api.value
                //             }
                //         };
                //     } else if (this.api.mode === 'bearer') {
                //         device_config = {
                //             auth: {
                //                 type: 'bearer',
                //                 token: this.api.token
                //             }
                //         };
                //     } else if (this.api.mode === 'basic') {
                //         device_config = {
                //             auth: {
                //                 type: 'basic',
                //                 username: this.api.username,
                //                 password: this.api.password
                //             }
                //         };
                //     }

                //     if (this.api.deviceId) {
                //         device_config.deviceId = this.api.deviceId;
                //     }
                // } else if (this.device.mode === 'mqtt') {
                //     device_config = {
                //         topic: this.mqtt.topic,
                //         clientId: this.mqtt.id,
                //         username: this.mqtt.username,
                //         password: this.mqtt.password
                //     };
                // }

                // Device object for update
                // const deviceData = {
                //     name: this.device.name,
                //     comment: this.device.comment || "",
                //     mode: this.device.mode,
                //     snumber: this.device.snumber || "",
                //     template_id: this.device.template_id,
                //     config: device_config
                // };

                // // Add device ID if editing existing device
                // if (this.device.device_id) {
                //     deviceData.id = this.device.device_id;
                // }

                // // Final request body
                // const body_edit_device = {
                //     plan: plan,
                //     devices: [deviceData],
                //     deleteDeviceIds: []
                // };

                // console.log('Editing device with data:', body_edit_device);

                const accessToken = localStorage.getItem("accessToken");
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/plan/${planId}/with-devices`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify(this.dataDeviceOne)
                });

                if (!response.ok) {
                    const error = await response.json();
                    throw new Error(error.message || `HTTP error! status: ${response.status}`);
                }

                const result = await response.json();
                console.log('Device edited successfully:', result);

                alert('แก้ไขอุปกรณ์สำเร็จ');
                this.clearForm();
                this.getAllDevice();

                // Close modal
                const modal = bootstrap.Modal.getInstance(document.getElementById('manageDeviceModal'));
                if (modal) modal.hide();

            } catch (error) {
                console.error('Error editing device:', error);
                alert('เกิดข้อผิดพลาด: ' + error.message);
            }
        },

        async getTemplateList() {
            try {
                var accessToken = localStorage.getItem("accessToken");
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/devices/template`, {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                const data = await response.json();
                console.log("success:", data);
                this.list_template = data.data;
            } catch (error) {
                console.error("Upload error:", error);
            }
        },

        copyTextFallback(text) {
            const textarea = document.createElement("textarea");
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            alert('คัดลอกแล้ว!');
        },

        async deleteDevice(id) {
            if (!confirm('คุณต้องการลบอุปกรณ์นี้ใช่หรือไม่?')) {
                return;
            }

            try {
                var accessToken = localStorage.getItem("accessToken");
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/plan/${id}?force=true`, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                alert('ลบอุปกรณ์สำเร็จ');
                this.getAllDevice();
            } catch (error) {
                console.error('Error deleting device:', error);
                alert('เกิดข้อผิดพลาดในการลบอุปกรณ์');
            }
        },

        openEditModal(item) {
            this.editMode = true;
            this.editPlanId = item.id;

            // Load plan data
            // this.device.plan_name = item.name || "";
            // this.device.customer = item.customer || "";
            // this.device.instrument = item.instrument || "";
            // this.device.model = item.model || "";
            // this.device.postcode = item.postcode || "";
            // this.device.location = item.location || "";
            // this.device.province = item.province || "";
            // this.device.status = item.status || 1;
            // this.device.latitude = item.Latitude || 0;
            // this.device.longitude = item.Longitude || 0;
            // this.device.setting = item.setting || "";
            // this.device.description = item.description || "";

            // Load first device data if available
            // if (item.devices && item.devices.length > 0) {
            //     const deviceData = item.devices[0];
            //     this.device.device_id = deviceData.id;
            //     this.device.name = deviceData.name || "";
            //     this.device.comment = deviceData.comment || "";
            //     this.device.mode = deviceData.mode || "api";
            //     this.device.snumber = deviceData.snumber || "";
            //     this.device.template_id = deviceData.template_id || "";

            //     // Load device config
            //     if (deviceData.config) {
            //         if (this.device.mode === 'mqtt') {
            //             this.mqtt.topic = deviceData.config.topic || "";
            //             this.mqtt.id = deviceData.config.clientId || "";
            //             this.mqtt.username = deviceData.config.username || "";
            //             this.mqtt.password = deviceData.config.password || "";
            //         } else if (this.device.mode === 'api' && deviceData.config.auth) {
            //             this.api.mode = deviceData.config.auth.type || "basic";

            //             if (this.api.mode === 'apikey') {
            //                 this.api.in = deviceData.config.auth.in || "header";
            //                 this.api.key = deviceData.config.auth.key || "";
            //                 this.api.value = deviceData.config.auth.value || "";
            //             } else if (this.api.mode === 'bearer') {
            //                 this.api.token = deviceData.config.auth.token || "";
            //             } else if (this.api.mode === 'basic') {
            //                 this.api.username = deviceData.config.auth.username || "";
            //                 this.api.password = deviceData.config.auth.password || "";
            //             }

            //             this.api.deviceId = deviceData.config.deviceId || "";
            //         }
            //     }
            // }

            // Open modal
            const modal = new bootstrap.Modal(document.getElementById('manageDeviceModal'));
            modal.show();
        },

        clearForm() {
            this.editMode = false;
            this.editPlanId = null;

            this.device = {
                template_id: "",
                plan_name: "",
                customer: "",
                instrument: "",
                model: "",
                postcode: "",
                location: "",
                province: "",
                status: 1,
                latitude: "",
                longitude: "",
                setting: "",
                description: "",
                snumber: "",
                name: "",
                mode: "api",
                comment: "",
                device_id: null
            };

            this.api = {
                mode: "basic",
                in: "header",
                key: "X-API-Key",
                value: "",
                username: "",
                password: "",
                token: "",
                deviceId: ""
            };

            this.mqtt = {
                id: "",
                topic: "",
                username: "",
                password: ""
            };
        },
        async getDeviceOneWithPlanID(pid) {
            try {
                var accessToken = localStorage.getItem("accessToken");
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/plan/${pid}/with-devices`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                this.configData = data.data;
                this.dataDeviceOne = data.data;
                console.log("Device with Plan ID:", data.data);

            } catch (error) {
                console.error('Error fetching dashboard data:', error);
            }
        },

        async getAllDevice() {
            try {
                var accessToken = localStorage.getItem("accessToken");
                this.loading = true;

                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/plan`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                this.list_device = data.data || [];
                this.total = data ?.meta ?.total || 0;
            } catch (error) {
                console.error('Error fetching dashboard data:', error);
                this.list_device = [];
                this.total = 0;
            } finally {
                this.loading = false;
            }
        },

        reload() {
            this.page = 1;
            this.getAllDevice();
        },

        nextPage() {
            if (!this.disableNext) {
                this.page += 1;
                this.getAllDevice();
            }
        },

        prevPage() {
            if (this.page > 1) {
                this.page -= 1;
                this.getAllDevice();
            }
        },
    },

    watch: {
        size() {
            this.reload();
        },
    },

    mounted() {
        this.getAllDevice();
        this.getTemplateList();
    },
};
</script>

<style scoped>
.edit_btn {
    background: #d4f4dd;
    color: #00ac4f;
    border: 1px solid #00ac4f;
}

.remove_btn {
    background: #ffe2e5;
    color: #fa5a7d;
    border: 1px solid #fa5a7d;
}

.dashboard {
    min-height: 100vh;
    background-color: #f5f6fa;
}

.header {
    background: white;
    padding: 20px 0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 0px;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header h1 {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    color: #1a1a1a;
}

.search-box {
    position: relative;
    width: 300px;
}

.search-box input {
    width: 100%;
    padding: 10px 10px 10px 40px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    font-size: 14px;
    background: #f9fafb;
    outline: none;
}

.search-box input:focus {
    border-color: #6366f1;
}

.search-box i {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
}

.main-content {
    padding-top: 40px;
    padding-bottom: 40px;
}

.stats-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    margin-bottom: 40px;
}

.stat-card {
    background: white;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    transition: transform 0.2s;
}

.stat-card:hover {
    transform: translateY(-2px);
}

.stat-content {
    display: flex;
    align-items: flex-start;
    gap: 16px;
}

.stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    flex-shrink: 0;
}

.icon-green {
    background: #d4f4dd;
    color: #00ac4f;
}

.icon-purple {
    background: #e5d9f2;
    color: #8b5cf6;
}

.stat-info {
    flex: 1;
}

.stat-label {
    color: #9ca3af;
    font-size: 14px;
    margin-bottom: 8px;
}

.stat-value {
    font-size: 32px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 8px 0;
}

.stat-change {
    font-size: 13px;
    font-weight: 500;
}

.change-up {
    color: #00ac4f;
}

.change-down {
    color: #fa5a7d;
}

.avatar-group {
    display: flex;
    margin-top: 8px;
}

.avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid white;
    margin-left: -8px;
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
}

.avatar:first-child {
    margin-left: 0;
}

.customers-section {
    background: white;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.section-title {
    font-size: 22px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0 0 8px 0;
}

.active-members {
    color: #16c098;
    font-size: 14px;
    font-weight: 500;
    text-decoration: underline;
}

.search-sort-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.sort-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
}

.sort-wrapper label {
    color: #9ca3af;
    font-size: 14px;
    margin: 0;
}

.sort-select {
    padding: 8px 16px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    font-size: 14px;
    color: #6b7280;
    background: white;
    cursor: pointer;
    outline: none;
}

.sort-select:focus {
    border-color: #6366f1;
}

.table-wrapper {
    overflow-x: auto;
}

.customers-table {
    width: 100%;
    min-width: 1100px;
    border-collapse: separate;
    border-spacing: 0;
}

.customers-table thead th {
    padding: 12px 16px;
    text-align: left;
    font-size: 14px;
    font-weight: 600;
    color: #6b7280;
    border-bottom: 1px solid #e5e7eb;
}

.customers-table tbody td {
    padding: 16px;
    font-size: 14px;
    color: #1a1a1a;
    border-bottom: 1px solid #f3f4f6;
}

.customers-table tbody tr:hover {
    background: #f9fafb;
}

.status-badge {
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 500;
    display: inline-block;
    min-width: 70px;
    text-align: center;
}

.status-active {
    background: #d4f4dd;
    color: #00ac4f;
    border: 1px solid #00ac4f;
}

.status-inactive {
    background: #ffe2e5;
    color: #fa5a7d;
    border: 1px solid #fa5a7d;
}

.pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #e5e7eb;
}

.pagination-info {
    color: #9ca3af;
    font-size: 14px;
}

.pagination-controls {
    display: flex;
    gap: 8px;
}

.page-btn {
    width: 32px;
    height: 32px;
    border: 1px solid #e5e7eb;
    background: white;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
    color: #6b7280;
    transition: all 0.2s;
}

.page-btn:hover:not(:disabled) {
    border-color: #6366f1;
    color: #6366f1;
}

.page-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.page-btn.active {
    background: #6366f1;
    color: white;
    border-color: #6366f1;
}

@media (max-width: 768px) {
    .stats-grid {
        grid-template-columns: 1fr;
    }

    .search-sort-bar {
        flex-direction: column;
        gap: 16px;
        align-items: stretch;
    }

    .search-box {
        width: 100%;
    }

    .table-wrapper {
        overflow-x: scroll;
    }
}

/* add device */

/* Header Card */
.header-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 2rem;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.15);
    color: white;
}

.icon-wrapper {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.8rem;
    backdrop-filter: blur(10px);
}

.header-card h3 {
    color: white;
    margin: 0;
}

.header-card p {
    color: rgba(255, 255, 255, 0.9);
}

/* Form Card */
.form-card {
    /* background: white; */
    /* padding: 2.5rem; */
    /* border-radius: 16px; */
    /* box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06); */
}

.section-header {
    display: flex;
    align-items: center;
    color: #2d3748;
    font-weight: 600;
}

.section-header i {
    color: #667eea;
    font-size: 1.3rem;
}

.section-divider {
    height: 2px;
    background: linear-gradient(to right, #e2e8f0, transparent);
    margin: 2rem 0;
}

/* Custom Input Styles */
.custom-label {
    display: block;
    font-weight: 500;
    color: #4a5568;
    margin-bottom: 0.5rem;
    font-size: 0.95rem;
}

.custom-input {
    width: 100%;
    padding: 0.85rem 1rem;
    border: 2px solid #e2e8f0;
    border-radius: 10px;
    font-size: 0.95rem;
    transition: all 0.3s ease;
    background: #fafafa;
}

.custom-input:focus {
    outline: none;
    border-color: #667eea;
    background: white;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.custom-input::placeholder {
    color: #a0aec0;
}

textarea.custom-input {
    resize: vertical;
}

select.custom-input {
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%234a5568' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 1rem center;
    padding-right: 2.5rem;
}

/* Configuration Box */
.config-box {
    background: #f7fafc;
    border: 2px solid #e2e8f0;
    border-radius: 12px;
    padding: 1.5rem;
    margin-top: 1rem;
}

.config-header {
    display: flex;
    align-items: center;
    color: #2d3748;
    font-size: 1rem;
    margin-bottom: 1.25rem;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid #e2e8f0;
}

.config-header i {
    color: #667eea;
}

.config-item {
    margin-bottom: 1rem;
}

.config-label {
    display: block;
    font-weight: 500;
    color: #4a5568;
    margin-bottom: 0.4rem;
    font-size: 0.85rem;
}

.custom-input-small {
    width: 100%;
    padding: 0.65rem 0.85rem;
    border: 2px solid #e2e8f0;
    border-radius: 8px;
    font-size: 0.9rem;
    transition: all 0.3s ease;
    background: white;
}

.custom-input-small:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

select.custom-input-small {
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%234a5568' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 0.85rem center;
    padding-right: 2.5rem;
}

.input-group-custom {
    display: flex;
    gap: 0.5rem;
}

.input-group-custom .custom-input-small {
    flex: 1;
}

.btn-copy {
    padding: 0.65rem 1rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    color: white;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    flex-shrink: 0;
}

.btn-copy:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

/* Info Box */
.info-box {
    background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
    padding: 1.25rem;
    border-radius: 10px;
    display: flex;
    align-items: start;
    border-left: 4px solid #f59e0b;
    margin-top: 1rem;
}

.info-box i {
    font-size: 1.5rem;
    margin-top: 0.1rem;
}

.info-box strong {
    color: #92400e;
    display: block;
}

.info-box p {
    color: #78350f;
    font-size: 0.9rem;
}

/* Buttons */
.button-row {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    padding-top: 2rem;
    border-top: 2px solid #e2e8f0;
}

.btn-clear {
    padding: 0.85rem 2rem;
    border: 2px solid #e2e8f0;
    background: white;
    color: #718096;
    border-radius: 10px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
}

.btn-clear:hover {
    background: #f7fafc;
    border-color: #cbd5e0;
    color: #2d3748;
    transform: translateY(-1px);
}

.btn-create {
    padding: 0.85rem 2.5rem;
    border: none;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.btn-create:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.btn-create:disabled {
    background: #cbd5e0;
    cursor: not-allowed;
    box-shadow: none;
}

/* Responsive */
@media (max-width: 991px) {
    .form-card {
        padding: 1.5rem;
    }

    .header-card {
        padding: 1.5rem;
    }

    .button-row {
        flex-direction: column-reverse;
    }

    .btn-clear,
    .btn-create {
        width: 100%;
        justify-content: center;
    }

    .input-group-custom {
        flex-direction: column;
    }

    .btn-copy {
        width: 100%;
    }
}
</style>
